import { RemoveHtmlTagsPipe } from './../../../../modules/shared/pipes/remove-html-tags.pipe';
import { OnlyTimePipe } from './../../../../modules/shared/pipes/only-time.pipe';
import { DynamicTableWidgetDetailsM } from './../../../../modules/shared/models/dynamic-table/dynamic-table-widget-details.model';
import { CustomNumberFormatPipe } from './../../../../modules/shared/pipes/custom-number-format.pipe';
import { ImportserialService } from './../../../../modules/shared/services/importserial.service';
import { CookieStoreService } from 'src/app/modules/shared/services/cookie-store.service';
import { MyDocumentsService } from './../../../../profile/my-documents/my-documents.service';
import { ReportsPrintPdfService } from './../../../../reports/servies/reports-print-pdf.service';
import { ParseHelper } from './../../../../modules/shared/parse.helper';
import { ActivityCommaSeparatedControls, CSVControls, CommaSeparatedControls } from './../../../../modules/shared/constants/formcontrol-list.constants';
import { TimeZoneService } from './../../../../modules/shared/services/timezone.service';
import { PermissionService } from './../../../../service/permission.service';
import { DocumentViewerService } from './../../../../modules/shared/services/document-viewer.service';
import { SharedColumnSettingsService } from './../../../../modules/shared/services/column-settings.service';
import { CurrencySymbolPipe } from './../../../../modules/shared/pipes/currency-symbol.pipe';
import { NumberToFixedPipe } from './../../../../modules/shared/pipes/number-tofixed.pipe';
import { ColumnSettingsN } from './../../../../modules/shared/models/column-settings.model';
import { AccountModuleId, LeadModuleId, OpportunityModuleId, ActivityModuleId, VendorModuleId, LocationModuleId, TaskModuleId } from './../../../../modules/shared/constants/modules.constant';
import { AppMainComponent } from './../../../../app.main.component';
import { AppMainService } from './../../../../app-main.service';
import { UserService } from './../../../../service/userservice';
import { LocalDatePipe } from './../../../../modules/shared/pipes/local-date.pipe';
import { CdkDragDrop, CdkDragStart, CDK_DRAG_CONFIG, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SavedSearchNS } from '../../models/saved-search.models';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { SavedSearchesService } from '../../services/saved-searches.service';
import { ISavedSearchColumnModel, ISavedSearchFilterModel } from '../../models/saved-search-filter.model';
import { SavedSearchMessage } from '../../models/saved-search.static';
import * as moment from 'moment';
import { isValidLatLng } from 'src/app/modules/shared/helpers/location.helper';
import { DatePipe } from '@angular/common';
import { TransactionNames } from 'src/app/finance/constants/constants';
import * as FileSaver from 'file-saver';
import { PrintPdfModel } from 'src/app/reports/models/reports-print-pdf-model';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { SavedSearchRecordService } from '../../services/saved-search-record.service';

declare var google: any;

const DragConfig = {
    dragStartThreshold: 0,
    pointerDirectionChangeThreshold: 5,
    zIndex: 99999
};

@Component({
    selector: 'app-saved-search-table-view',
    templateUrl: './saved-search-table-view.component.html',
    styleUrls: ['./saved-search-table-view.component.scss'],
    providers: [{ provide: CDK_DRAG_CONFIG, useValue: DragConfig }, LocalDatePipe, OnlyTimePipe, RemoveHtmlTagsPipe, DatePipe, CustomNumberFormatPipe]
})
export class SavedSearchTableViewComponent implements OnInit, OnDestroy, OnChanges {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() addEditType: 'Select' | 'View' | 'Edit' | 'Delete' | 'None' = 'Select';
    @Input() savedSearchId: number;
    @Input() tabWidgetDetails: DynamicTableWidgetDetailsM;
    @Input() showFlatTable: boolean = false;
    @Input() loadFromResponse: boolean = false;
    @Input() savedSearchResponse: any;
    @Input() isLeftTableHide: boolean = false;
    @Input() refreshSavedSearch: boolean = false;
    @Input() openColumnSettings: boolean = false;
    @Input() exportSavedSearch: boolean = false;
    @Input() inPageMenu: boolean = false;
    @Input() hideTableHeader: boolean = false;

    selectedSearch: SavedSearchNS.ISavedSearchOverview;

    //Restul List
    pageSize2: number = 15;
    totalRecords2: number = 0;
    tableShowMore2: number[] = [15, 30, 50, 100, 500, 1000];
    first2: number = 0;
    resultData: any = [];
    resultDataCopy = [];
    filterByInputValue = [];
    pcalendarCustom: Date = new Date();
    ecalendarCustom: Date = new Date();

    displayExportDialog: boolean = false;
    isActive: boolean = true;
    colSettingSearchInput: string = '';
    displayDetailPopup = false;
    popupDataId: number = 0;
    popupModuleType: string = '';
    popupHeader: string = '';
    selectedResultFilters: ISavedSearchFilterModel[] = [];
    noData = "No Data Found";
    fromGroupBy: boolean = false;
    groupByParams: any;
    orderByParams: any;
    reportTotalRow: any = {};
    groupBySavedResults: any;
    groupByCol: any;
    dateRangeForDatetime: boolean = true;
    showOrderByFilter: boolean = true;

    //Column Settings
    displayColSetting = false;
    displayAddressSelect = false;
    startDrag = false;
    totalAmt = 0;
    maxNo = false;
    columnSettingsN: Partial<ColumnSettingsN> = {};
    disabledLabelNames: string[] = [];
    displayColumnSettings: boolean = false;
    tempColumnSettings: any = null;

    inventoryHiperLinkFields = ['trans_invoiceno', 'trans_estimateno', 'trans_salesorderno','trans_rmano', 'trans_memonumber'];
    hiperLinkFields: string[] = ['businessname','name','associationname','vendorname','taskid',...this.inventoryHiperLinkFields];

    //CRM Overview
    selectedChannelId: number = 0;
    selectedChannelIdForView: number = 0;
    selectedAccountChannelId: number = 0;
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number = 0;
    displayLeadViewEdit: boolean = false;
    displayTaskViewEdit: boolean = false;
    selectedLeadId: number = 0;
    selectedTaskId: number = 0;
    displayOpportunityViewEdit: boolean = false;
    opportunityEditViewId: number = 0;

    //Inventory Overview
    transactionNames = TransactionNames;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";

    //Saved Search MapView
    showMapList: boolean = false;
    tableViewMode = [
        { label: 'List View', value: 'list' },
        { label: 'Map View', value: 'map' }
    ];
    savedSearchMapView: 'list' | 'map' = 'list';
    savedSearchMap: any;
    mapInfoWindow: any;
    savedSearchMapMarkers: any[] = [];

    //decimal fractiondigits
    maximumFractionDigits: number = 2;
    savedSearchHeading: string = "Saved Search"; 

    //Venodr Overview
    displayVendorOverview: boolean = false;
    selectedVendorDetails: any;
    selectAllSectionsFields: boolean = false;

    constructor(
        public _ngZone: NgZone,
        public userService: UserService,
        private appMainService: AppMainService,
        public app: AppMainComponent,
        private savedSearchesService: SavedSearchesService,
        private localDatePipe: LocalDatePipe,
        private onlyTimePipe: OnlyTimePipe,
        private removeHtmlTags: RemoveHtmlTagsPipe,
        private datePipe: DatePipe,
        private numberToFixedPipe: NumberToFixedPipe,
        private messageService: MessageService,
        private customNumberFormatPipe: CustomNumberFormatPipe,
        private currencyPipe: CurrencySymbolPipe,
        private sharedColumnSettingsService: SharedColumnSettingsService,
        private documentViewerService: DocumentViewerService,
        private permissionService: PermissionService,
        private documentService: MyDocumentsService,
        private timeZoneService: TimeZoneService,
        private cookieStoreService: CookieStoreService,
        private importserialService: ImportserialService,
        private purchaseService: PurchasesService,
        private savedSearchRecordService: SavedSearchRecordService,
    ) { }

    ngOnInit(): void {
        window["cpntRef"] = { component: this, zone: this._ngZone };
        this.setFractionDigits();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['savedSearchResponse']?.currentValue){
            this.savedSearchResponse = changes['savedSearchResponse']?.currentValue;
            if(this.savedSearchResponse && this.loadFromResponse){
                this.selectSavedSearchFromResponse();
            }
        }
        if(changes['savedSearchId']?.currentValue){
            this.savedSearchId = changes['savedSearchId']?.currentValue;
            if(this.savedSearchId>0 && !this.loadFromResponse){
                this.selectSavedSearch();
            }
        }

        if(changes['refreshSavedSearch']?.currentValue){
            this.refreshSavedSearch = changes['refreshSavedSearch']?.currentValue;
            if(this.refreshSavedSearch){
                this.refreshSavedSearchQuery();
            }
        }

        if(changes['openColumnSettings']?.currentValue){
            this.openColumnSettings = changes['openColumnSettings']?.currentValue;
            if(this.openColumnSettings){
                this.showColumnSetting();
            }
        }

        if(changes['exportSavedSearch']?.currentValue){
            this.exportSavedSearch = changes['exportSavedSearch']?.currentValue;
            if(this.exportSavedSearch){
                this.onExport();
            }
        }
    }

    setFractionDigits(){
        this.importserialService.getDecimalValue().subscribe(value=>{
            this.maximumFractionDigits = value||this.maximumFractionDigits;
        });
    }

    selectSavedSearch() {
        this.clearTableData();
        this.appMainService.isShowSpinner('getSavedSearchById');
        this.savedSearchesService.getSavedSearchById(this.savedSearchId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.appMainService.isHideSpinner('getSavedSearchById');
                this.setSavedSearchDetails(response);
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('getSavedSearchById');
            }
        });
    }

    selectSavedSearchFromResponse() {
        this.clearTableData();
        this.setSavedSearchDetails(this.savedSearchResponse);
    }

    clearTableData(){
        //Clear Table Data First
        this.resultData = [];
        this.totalRecords2 = 0;
        this.savedSearchRecordService.setTotalRecords(this.totalRecords2);
        this.reportTotalRow = {};
        this.groupByParams = null;
        this.orderByParams = null;
        this.fromGroupBy = false;
    }

    setSavedSearchDetails(resp: any){
        if(resp){
            this.selectedSearch = resp;
            this.savedSearchId = this.selectedSearch.id;
            this.selectedSearch.savedSearchRuleRequest = this.getViewRuleRequest(resp.savedSearchRule);
            this.selectedSearch.oldCreatedDate = resp?.createdDate || this.selectedSearch.createdDate;
            this.selectedSearch.savedSearchUserPermission = resp.savedSearchUserPermission;
            this.selectedSearch.moduleId = resp?.moduleId;
            this.selectedSearch.channelId = resp?.channelId;
            this.selectedSearch.accountChannelId = resp?.accountChannelId;


            const mainModule: SavedSearchNS.SavedSearchRuleRequest = this.selectedSearch.savedSearchRuleRequest.find(x => x.isMainModule == true);
            if (mainModule) {
                if (!resp?.moduleId) {
                    this.selectedSearch.moduleId = mainModule.objectId;
                    this.selectedSearch.accountChannelId = mainModule.accountChannelId;
                }
                if (!this.selectedSearch?.channelId) {
                    this.selectedSearch.channelId = mainModule.templateId;
                }
            }

            this.selectedSearch.objectId = this.selectedSearch.moduleId;
            this.selectedSearch.templateId = this.selectedSearch.channelId;
            this.selectedAccountChannelId = this.selectedSearch.accountChannelId || 0;
            this.selectedChannelId = this.selectedSearch.channelId;

            if(!this.showFlatTable){
                this.groupByParams = JSON.parse(resp.savedSearchGroupBy);
                this.orderByParams = this.groupByParams?.orderBy || null;
                this.fromGroupBy = !!this.groupByParams?.groupBy?.columnName;
                if (this.groupByParams?.aggregatedFields?.length > 0) {
                    this.groupBySavedResults = { aggregationType: this.groupByParams.aggregatedFields[0].aggregationType };
                }
            }

            this.showMapList = false;
            this.savedSearchMapView = 'list';

            if([AccountModuleId].includes(this.selectedSearch?.objectId)){
                this.showMapList = true;
            }

            if ([AccountModuleId, LeadModuleId, TaskModuleId, OpportunityModuleId, ActivityModuleId, VendorModuleId, LocationModuleId].includes(this.selectedSearch?.objectId)) {
                this.getColumnSettings(this.addEditType);
            } else {
                if (resp?.savedSearchColumnSetting?.find(x => x.statusId == 1)) {
                    let selectedColums = JSON.parse(resp?.savedSearchColumnSetting?.find(x => x.statusId == 1)?.value ?? []);
                    this.selectedSearch.savedSearchColumnSetting = selectedColums;
                    this.tempColumnSettings =  ParseHelper.DeepCopy(selectedColums);
                    this.calculateColumnSettingsMax();
                    if (this.addEditType != 'None') {
                        //remove filter group
                        this.selectedSearch.columns = [];
                        setTimeout(() => {
                            this.selectedSearch.columns = this.getColumnSettingsForTable(selectedColums);
                        }, 0);
                    }
                }

                this.filterByInputValue = [];
                this.resetResultPagination();
                this.getSavedSearchResultOnListIndex(1, this.pageSize2);
            }
        }
    }

    getViewRuleRequest(savedSearchRule: any[]): SavedSearchNS.SavedSearchRuleRequest[] {
        let ruleRequest: SavedSearchNS.SavedSearchRuleRequest[] = [];
        if (savedSearchRule) {
            savedSearchRule.forEach(element => {
                if (element?.dataType == 'Enum') {
                    if (element?.criteria?.toLowerCase() == 'territoryname') {
                        element.valuesJson = JSON.parse(element?.values[0] || 'null');
                    }
                }
                else if (element?.dataType == 'Distance') {
                    element.valuesJson = JSON.parse(element?.values[0] || 'null');
                }
                else {
                    element.valuesJson = null;
                }
                ruleRequest.push(element);
            });
        }
        if (ruleRequest) {
            ruleRequest = ruleRequest.sort((a, b) => (a.sequenceOrder > b.sequenceOrder) ? 1 : -1);
        }
        return ruleRequest;
    }

    //#region Saved Result Data

    resetResultPagination() {
        this.first2 = 0;
    }

    refreshSavedSearchQuery() {
        this.savedSearchesService.regenerateSavedSearcQuery(this.selectedSearch.moduleId, this.selectedSearch.id)
            .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.resetResultPagination();
                    this.getSavedSearchResultOnListIndex(1, this.pageSize2);
                },
                error: (error) => {

                }
            });
    }

    getSavedSearchResultByFilter(event: LazyLoadEvent): void {
        if (!event.sortField && !event.filters) {
            if (event.first == 0 && event.rows == 15) {
                this.getSavedSearchResultOnListIndex(1, 15);
                return;
            }
        }
        const pageSize: number = event.rows;
        const pageNumber: number = (event.first / event.rows) + 1;
        this.getSavedSearchResultOnListIndex(pageNumber, pageSize);
    }

    getSavedSearchResultOnListIndex(pageNumber: number, pageSize: number, exportType: string = null): void {
        const filters = this.prepareSavedSearchFiltersValue();
        if (this.fromGroupBy) {
            this.getGroupBySavedSearchResult(pageNumber, pageSize, this.selectedSearch.id, filters, exportType)
        } else {
            this.getSavedSearchResult(pageNumber, pageSize, this.selectedSearch.id, filters, exportType);
        }
    }

    getSavedSearchResultQuery(
        pageNumber: number,
        pageSize: number,
        savedSearchId: number,
        filters?: SavedSearchNS.SavedSearchQueryFilters[],
        type: 'flat' | 'group' = 'flat'
    ): any {
        const aggregatedBy = this.groupByParams?.aggregatedFields?.length > 0 ? this.groupByParams?.aggregatedFields : null;
        const orderByParams = this.orderByParams ? ParseHelper.DeepCopy(this.orderByParams) : null;

        if(filters?.length>0){
            filters.map(filter => {
                filter.values = filter.values?.length > 0 ? filter.values.map(str => typeof str === 'string' ? str.replace("'", "''") : str) : filter.values;
            });
        }

        const flatQueryData: SavedSearchNS.SavedSearchResultQuery = {
            savedSearchId: savedSearchId,
            pageNumber: pageNumber,
            pageSize: pageSize,
            filters: filters,
            aggregatedBy: aggregatedBy,
            orderBy: orderByParams
        };

        let groupQueryData: SavedSearchNS.SavedSearchGroupedResultQuery = null;
        if (type == 'group') {

            const groupBy = this.groupByParams?.groupBy ? {
                ...this.groupByParams?.groupBy,
                timezone: (this.groupByParams?.groupBy?.isDateWithTime) ? this.timeZoneService.getUserTimezoneName() : null
            } : null;

            const subGroupBy = this.groupByParams?.subGroupBy ? {
                ...this.groupByParams?.subGroupBy,
                timezone: (this.groupByParams?.subGroupBy?.isDateWithTime) ? this.timeZoneService.getUserTimezoneName() : null
            } : null;

            groupQueryData = {
                ...flatQueryData,
                groupOrderBy: this.groupByParams?.groupOrderBy || null,
                groupBy: groupBy,
                subGroupOrderBy: this.groupByParams?.subGroupOrderBy || null,
                subGroupBy: subGroupBy
            };

            if (groupQueryData.orderBy?.limit) {
                if (groupQueryData.groupOrderBy) {
                    groupQueryData.groupOrderBy.limit = groupQueryData.orderBy?.limit || null;
                }
                groupQueryData.orderBy.limit = null;
            }
        }

        this.disabledLabelNames = [];
        if (flatQueryData.aggregatedBy) {
            flatQueryData.aggregatedBy.map(a => {
                this.disabledLabelNames.push(a.columnName);
            })
        }

        if (groupQueryData?.groupBy?.columnName) {
            this.disabledLabelNames.push(groupQueryData.groupBy?.columnName);
        }

        if (groupQueryData?.subGroupBy?.columnName) {
            this.disabledLabelNames.push(groupQueryData.subGroupBy?.columnName);
        }

        if (flatQueryData.orderBy) {
            this.disabledLabelNames.push(flatQueryData.orderBy.columnName);
        }

        return type == 'group' ? groupQueryData : flatQueryData;
    }

    getSavedSearchResult(pageNumber: number, pageSize: number, savedSearchId: number, filters?: SavedSearchNS.SavedSearchQueryFilters[], exportType: string = null) {
        this.appMainService.isShowSpinner('getSavedSearchResult');

        const queryData: SavedSearchNS.SavedSearchResultQuery = this.getSavedSearchResultQuery(pageNumber, pageSize, savedSearchId, filters);

        this.savedSearchesService.getSavedSearchPostResults(queryData)
            .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('getSavedSearchResult');

                    if(exportType){
                        this.exportToExcel(response?.results?.Result ?? [], exportType);
                        return;
                    }

                    this.resultData = response?.results?.Result ?? [];
                    this.totalRecords2 = 0;
                    if (this.resultData?.length > 0) {
                        this.totalRecords2 = this.resultData[0]?.TotalNoOfRecords || 0;
                    }
                    this.savedSearchRecordService.setTotalRecords(this.totalRecords2);
                    this.reportTotalRow = {};

                    if (this.groupByParams?.aggregatedFields?.length > 0 && this.resultData?.length > 0) {
                        const keys = Object.keys(this.resultData[0]);
                        for (let k of keys) {
                            const dt = this.groupByParams.aggregatedFields.filter(ky => ky.columnName == k)[0];
                            if (dt) {
                                const field = `Aggregated_${dt.columnName}`;
                                const paginatedField = `Paginated_${dt.columnName}`;
                                this.reportTotalRow[dt.columnName] = this.resultData[0]?.[field];
                                this.reportTotalRow[paginatedField] = this.resultData[0]?.[paginatedField];
                            }
                        }
                    }

                    this.changeViewMode();
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getSavedSearchResult');
                    this.totalRecords2 = 0;
                    this.savedSearchRecordService.setTotalRecords(this.totalRecords2);
                    this.resultData = [];
                }
            });
    }

    getGroupBySavedSearchResult(pageNumber: number, pageSize: number, savedSearchId: number, filters: SavedSearchNS.SavedSearchQueryFilters[], exportType: string = null) {
        this.appMainService.isShowSpinner('getSavedSearchResult');

        const queryData: SavedSearchNS.SavedSearchGroupedResultQuery = this.getSavedSearchResultQuery(pageNumber, pageSize, savedSearchId, filters, 'group');

        this.savedSearchesService.getSavedSearchPostGroupedResults(queryData)
            .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('getSavedSearchResult');

                    if(exportType){
                        this.exportToExcel(response?.results?.Result ?? [], exportType);
                        return;
                    }

                    let responseData = response.results == null ? [] : response.results;
                    this.groupByCol = this.selectedSearch.columns?.filter(col => col.field == this.groupByParams?.groupBy?.columnName)[0];
                    this.totalRecords2 = 0;
                    this.resultData = [];
                    this.reportTotalRow = {};
                    this.resultData = responseData.Result || [];
                    if (this.resultData?.length > 0) {
                        this.totalRecords2 = this.resultData[0]?.TotalNoOfRecords || 0;
                        this.reportTotalRow['Aggregated_GroupNameCount'] = this.resultData[0]?.Aggregated_GroupNameCount;
                        const keys = Object.keys(this.resultData[0])
                        for (let k of keys) {
                            const dt = this.groupByParams.aggregatedFields.filter(ky => ky.columnName == k)[0];
                            if (dt) {
                                const field = `Aggregated_${dt.columnName}`;
                                this.reportTotalRow[dt.columnName] = this.resultData[0]?.[field];
                            }
                        }
                    }
                    this.savedSearchRecordService.setTotalRecords(this.totalRecords2);

                    this.fromGroupBy = true;
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getSavedSearchResult');
                    this.totalRecords2 = 0;
                    this.savedSearchRecordService.setTotalRecords(this.totalRecords2);
                    this.reportTotalRow = {};
                    this.resultData = [];
                }
            });
    }

    convertToCurrency(value) {
        const valueArray = value.split(',')
        let currencyString = [];
        for (let val of valueArray) {
            const decimal = (Number(val).toFixed(2));
            const currency = (this.currencyPipe.transform(decimal))
            currencyString.push(currency)
        }
        return (currencyString.join(','))
    }

    // convertToAggregate(value, col) {
    //     if (value) {
    //         const valueArray = value.toString().split(',')
    //         const data = [];
    //         for (let val of valueArray) {
    //             const decimal = (Number(val).toFixed(2));
    //             data.push(Number(decimal))
    //         }
    //         let total = 0;
    //         if (this.groupBySavedResults?.aggregationType == 'Sum' || this.groupBySavedResults?.aggregationType == 'Avg' ||
    //             this.groupBySavedResults?.aggregationType == 'Max' || this.groupBySavedResults?.aggregationType == 'Min') {
    //             for (let dt of data) {
    //                 total = total + dt;
    //             }
    //             const decimal = total.toFixed(2);
    //             return (col.dataType == 'currency' ? this.currencyPipe.transform(decimal) : total);
    //         }
    //     }
    // }

    // calculateAggregate(data, col) {
    //     const isAggField = this.groupByParams?.aggregatedFields?.filter(cl => cl.columnName == col.field)[0];
    //     if (isAggField) {
    //         const aggData = [];
    //         let aggTotal = 0;
    //         for (let dt of data.SavedSearchResult) {
    //             if (dt[col.field]) {
    //                 const valueArray = dt[col.field].toString().split(',')
    //                 const values = [];
    //                 for (let val of valueArray) {
    //                     const decimal = (Number(val).toFixed(2));
    //                     values.push(Number(decimal))
    //                 }
    //                 let total = 0;

    //                 if (this.groupBySavedResults?.aggregationType == 'Sum' || this.groupBySavedResults?.aggregationType == 'Avg' ||
    //                     this.groupBySavedResults?.aggregationType == 'Min' || this.groupBySavedResults?.aggregationType == 'Max') {
    //                     for (let dt of values) {
    //                         total = total + dt;
    //                     }
    //                 }
    //                 aggData.push(Number(total.toFixed(2)));
    //             }
    //         }
    //         for (let dt of aggData) {
    //             aggTotal = Number(aggTotal) + Number(dt);
    //         }

    //         let returnValue = null;

    //         if (this.groupBySavedResults?.aggregationType == 'Sum') {
    //             const decimalAggTotal = aggTotal.toFixed(2);
    //             returnValue = (col.dataType == 'currency' ? this.currencyPipe.transform(decimalAggTotal,'number2dp') : this.numberToFixedPipe.transform(aggTotal));
    //         } else if (this.groupBySavedResults?.aggregationType == 'Avg') {
    //             aggTotal = isNaN(Number(aggTotal / aggData.length)) ? 0 : Number(aggTotal / aggData.length);
    //             const decimalAggTotal = (isNaN(aggTotal) || !isFinite(aggTotal)) ? 0 : aggTotal.toFixed(2);
    //             returnValue = (col.dataType == 'currency' ? this.currencyPipe.transform(decimalAggTotal,'number2dp') :  this.numberToFixedPipe.transform(aggTotal))
    //         } else if (this.groupBySavedResults?.aggregationType == 'Min') {
    //             const min = isNaN(Math.min(...aggData)) || !isFinite(Math.min(...aggData)) ? 0 : Math.min(...aggData);
    //             const decimalAggTotal = (isNaN(min) || !isFinite(min)) ? 0 : min.toFixed(2);
    //             returnValue = (col.dataType == 'currency' ? this.currencyPipe.transform(decimalAggTotal,'number2dp') : min)
    //         } else if (this.groupBySavedResults?.aggregationType == 'Max') {
    //             const max = isNaN(Math.max(...aggData)) || !isFinite(Math.max(...aggData)) ? 0 : Math.max(...aggData);
    //             const decimalAggTotal = (isNaN(max) || !isFinite(max)) ? 0 : max.toFixed(2);
    //             returnValue = (col.dataType == 'currency' ? this.currencyPipe.transform(decimalAggTotal,'number2dp') : max)
    //         }

    //         if((col?.header=='Probability' || col?.header=='Rep Confidence') && returnValue!==null){
    //             returnValue = `${returnValue}%`;
    //         }

    //         return returnValue;
    //     }
    // }

    checkDataType(value) {
        return typeof (value)
    }

    //#endregion

    //#region Saved Search Filter

    prepareSavedSearchFiltersValue(): SavedSearchNS.SavedSearchQueryFilters[] | null {
        if(this.tabWidgetDetails){
            const x = this.selectedSearch.columns.find(col=> col.id==this.tabWidgetDetails.referenceFieldId);

            if(!x) return null;

            const filter: SavedSearchNS.SavedSearchQueryFilters = {
                columnName: x.field,
                dataType: x.fieldDataType,
                isCustom: x.isCustom,
                values: this.tabWidgetDetails.values,
                isCsv: x.isCommaSeperated
            }

            return [filter];
        }else{
            let savedSearchFilterSearchValueJson: SavedSearchNS.SavedSearchQueryFilters[] = [];
            if (this.selectedResultFilters?.length > 0) {
                const savedSearchFilterSearchValue = this.selectedResultFilters.map(x => {
                    let values: any = ParseHelper.DeepCopy(x.values);
                    if (x.fieldDataType == 'DateTime' && this.dateRangeForDatetime) {
                        if (x?.dateRangeTo && x?.dateRangeFrom) {

                            let dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(x?.dateRangeFrom, (x?.isDateWithTime || false), true, !['this month', 'last month', 'custom'].includes(x.rangeCode));
                            let dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(x.dateRangeTo, (x?.isDateWithTime || false), true, !['this month', 'last month', 'custom'].includes(x.rangeCode));
                            dateRangeTo.setDate(dateRangeTo.getDate() + 1);
                            dateRangeTo = new Date(dateRangeTo.getTime() - 1000);

                            values = [this.timeZoneService._getUTCDateTimeString(dateRangeFrom), this.timeZoneService._getUTCDateTimeString(dateRangeTo)];
                        } else {
                            values = [this.localDatePipe.transform(new Date(), 'MM/DD/YYYY'), this.localDatePipe.transform(new Date(), 'MM/DD/YYYY')];
                        }
                    }

                    const filter: SavedSearchNS.SavedSearchQueryFilters = {
                        columnName: x.field,
                        dataType: x.fieldDataType,
                        isCustom: x.isCustom,
                        values: values,
                        isCsv: x.isCommaSeperated
                    }

                    return filter
                });

                savedSearchFilterSearchValueJson = savedSearchFilterSearchValue;
            }
            return savedSearchFilterSearchValueJson?.length > 0 ? savedSearchFilterSearchValueJson : null;
        }
    }

    onGroupByFilter(data, type: 'group'|'order' = 'group') {
        if(type=='group'){
            this.groupByParams = data;
        } else {
            this.orderByParams = data;
        }

        const saveData = {
            ...this.groupByParams,
            groupOrderBy: null,
            subGroupOrderBy: null,
            orderBy: this.orderByParams
        }

        if(this.orderByParams){
            const exist = this.groupByParams?.aggregatedFields?.find(cl => cl.columnName == this.orderByParams?.columnName);
            if(exist){
                saveData.groupOrderBy = {
                    columnName: this.orderByParams?.columnName,
                    dataType: this.orderByParams?.dataType,
                    isDescending: this.orderByParams?.isDescending,
                    limit: this.orderByParams?.limit||null,
                }
            }else if(this.groupByParams?.groupBy?.columnName==this.orderByParams?.columnName){
                saveData.groupOrderBy = {
                    columnName: this.orderByParams?.columnName,
                    dataType: this.orderByParams?.dataType,
                    isDescending: this.orderByParams?.isDescending,
                    limit: this.orderByParams?.limit||null,
                }
            }

            if(this.groupByParams?.subGroupBy?.columnName==this.orderByParams?.columnName){
                saveData.subGroupOrderBy = {
                    columnName: this.orderByParams?.columnName,
                    dataType: this.orderByParams?.dataType,
                    isDescending: this.orderByParams?.isDescending,
                    limit: this.orderByParams?.limit||null,
                }
            }
        }

        this.saveGroupByOption(JSON.stringify(saveData));
    }

    saveGroupByOption(params) {
        this.appMainService.isShowSpinner('getSavedSearchResult');
        this.savedSearchesService.saveGroupByOption(this.selectedSearch.id, params)
            .then(() => {
                this.groupByParams = JSON.parse(params);
                if(this.groupByParams?.aggregatedFields?.length>0){
                    this.groupBySavedResults = { aggregationType: this.groupByParams.aggregatedFields[0].aggregationType };
                }
                if(this.groupByParams?.groupBy?.columnName){
                    this.fromGroupBy = true;
                }else{
                    this.fromGroupBy = false;
                }

                this.resetResultPagination();
                this.getSavedSearchResultOnListIndex(1, this.pageSize2);
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getSavedSearchResult');
            });
    }

    onResetGroupByFilter(type: 'group'|'order' = 'group') {
        this.appMainService.isShowSpinner('getSavedSearchResult');
        let saveData: any = null;

        if(type=='group' && this.orderByParams){
            saveData = JSON.stringify({
                orderBy: this.orderByParams
            })
        }else if(type=='order' && this.groupByParams){
            saveData = JSON.stringify({
                ...this.groupByParams,
                orderBy: null,
                groupOrderBy: null
            })
        }

        this.savedSearchesService.saveGroupByOption(this.selectedSearch.id, saveData)
            .then(() => {

                if(type=='group'){
                    this.fromGroupBy = false;
                }else{
                    this.orderByParams = null;
                }
                this.groupByParams = JSON.parse(saveData);
                this.resetResultPagination();
                this.getSavedSearchResultOnListIndex(1, this.pageSize2);
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getSavedSearchResult');
            });
    }

    //Apply Filter logic
    private applyFilter(selectedFilters: ISavedSearchFilterModel[], applyType: 'apply' | 'modify') {
        if (applyType == 'apply') {
            this.selectedResultFilters = selectedFilters ?? [];
            this.resetResultPagination();
            this.getSavedSearchResultOnListIndex(1, this.pageSize2);
        }
    }

    onOptionsFilter(event: { searchValue: string, selectedFilter: ISavedSearchFilterModel, selectedFilters: ISavedSearchFilterModel[] }): void {
        if (this.selectedSearch?.id && event?.selectedFilter) {
            if (event?.selectedFilter?.fieldDataType == 'DateTime' && event?.searchValue !== null) {
                if (moment(event.searchValue, "MM/DD/YYYY", true)?.isValid() == false) {
                    return;
                }
            }
            let filters = this.prepareSavedSearchFiltersValue();
            filters = (filters?.length>0 && event.selectedFilters?.length>0) ? filters.filter(addedFilter=> event.selectedFilters.find(newFilter=> newFilter.field==addedFilter.columnName)) : null;

            const postData: SavedSearchNS.SavedSearchQueryFilters = {
                savedSearchId: this.selectedSearch.id,
                columnName: event.selectedFilter.field,
                dataType: event.selectedFilter.fieldDataType||'Enum',
                values: (event.searchValue || event.searchValue=='0') ? [event.searchValue] : [],
                isCustom: event?.selectedFilter?.isCustom ,
                isCsv: event?.selectedFilter?.isCommaSeperated||false,
                isOrderByDescending: true,
                pageNumber: 1,
                pageSize: 100,
                filters: filters
            }

            this.savedSearchesService.getSavedSearcFilterValues(postData)
                .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (response) => {
                        this.parseMultiSelectDataTypes((response?.Result||[]));
                    },
                    error: (error) => {
                    }
                });
        }
    }

    //when apply any filter
    onApplyFilter(selectedFilters: ISavedSearchFilterModel[]): void {
        this.applyFilter(selectedFilters, 'apply');
    }
    //when Edit applied filter
    onModifyFilterOptions(selectedFilters: ISavedSearchFilterModel[]): void {
        this.applyFilter(selectedFilters, 'modify');
    }

    onRemoveFilter(selectedFilters: ISavedSearchFilterModel[]): void {
        this.onApplyFilter(selectedFilters);
    }

    resetFilterAndDate() {
        this.selectedResultFilters = [];
    }

    parseMultiSelectDataTypes(listData: any[]): void {
        let filterByInputValue = ParseHelper.DeepCopy(listData);
        if (filterByInputValue?.length > 0) {
            for (const col of this.selectedSearch.columns) {
                let oneTypeData;
                if (col.dataType == 'string' && col?.isCommaSeperated) {
                    oneTypeData = filterByInputValue.filter(obj => !obj[col.field]?.toString()?.includes(','));
                } else {
                    oneTypeData = filterByInputValue;
                }
                const moreTypesData = filterByInputValue.filter(obj => col.isCommaSeperated && obj[col.field]?.toString()?.includes(','));
                filterByInputValue = [...oneTypeData];
                moreTypesData.map(moreTypes => {
                    const types = moreTypes[col.field].split(',');
                    types.map(splitType => {
                        moreTypes[col.field] = splitType.trim();
                        filterByInputValue.push(ParseHelper.DeepCopy(moreTypes));
                    })
                });

            }
        }
        this.filterByInputValue = filterByInputValue;
    }

    //#endregion

    //#region Column Settings

    getColumnSettingsForTable(selectedColums: SavedSearchNS.SavedSearchColumnSetting[]): any[] {
        this.selectedResultFilters = [];
        let columns: ISavedSearchColumnModel[] = [];
        if (selectedColums) {
            let i = 1;
            selectedColums?.map(f => {
                f?.fields?.filter(f => f.isSelected == true)?.map(x => {
                    //nested field
                    if (x?.nestedFields?.length > 0) {
                        x.nestedFields?.filter(n => n.isSelected == true)?.map(nestObj => {

                            let dataType: any = nestObj.fieldDataType == 'DateTime' ? 'date' : (nestObj.fieldDataType == 'Number' || nestObj.fieldDataType == 'Decimal') && nestObj.fieldName != 'Qty' ? 'number' : nestObj.fieldDataType == 'Money' ? 'currency' : 'string';

                            columns.push(
                                {
                                    id: i + 1,
                                    field: this.prepareColumnNameFromCriteria(nestObj.criteriaUsed),
                                    header: `${x.name}: ${nestObj.labelName}`,
                                    fieldNameDB: nestObj.fieldName,
                                    dataType: dataType,
                                    fieldDataType: nestObj.fieldDataType,
                                    formControlType: nestObj?.formControlType,
                                    isShow: nestObj.isSelected,
                                    isCommaSeperated: nestObj.IsCommaSeperatedAndNumber,
                                    isCustom: x.isCustom,
                                    isDateWithTime: (!nestObj.isCustom && nestObj.fieldDataType == 'DateTime'),
                                    isCsv: false
                                });
                            i = i + 1;
                        })
                    }
                    else {
                        columns.push(
                            {
                                id: i + 1,
                                field: this.prepareColumnNameFromCriteria(x.criteriaUsed),
                                header: x.labelName,
                                fieldNameDB: x.fieldName,
                                dataType: x.fieldDataType == 'DateTime' ? 'date' : (x.fieldDataType == 'Number' || x.fieldDataType == 'Decimal') ? 'number' : x.fieldDataType == 'Money' ? 'currency' : 'string',
                                fieldDataType: x.fieldDataType as any,
                                formControlType: x?.formControlType,
                                isShow: x.isSelected,
                                isCustom: x.isCustom,
                                isDateWithTime: (!x.isCustom && x.fieldDataType == 'DateTime'),
                                isCommaSeperated: x.IsCommaSeperatedAndNumber,
                                isCsv: false
                            });
                        i = i + 1;
                    }
                });
            });
        }

        return columns;
    }

    prepareColumnNameFromCriteria(str?: string) {
        return str?.length > 0 ? str[0].toLocaleLowerCase() + str.slice(1) : str;
    }

    getLAColumnSettingsForTable(selectedColums: Partial<ColumnSettingsN>): any[] {
        // console.log(selectedColums);
        this.selectedResultFilters = [];
        let columns: ISavedSearchColumnModel[] = [];
        if (selectedColums.listViewSections) {
            selectedColums?.listViewSections.map(f => {
                f.fields = f.fields.sort((a,b)=> (a?.displayOrder||0) - (b?.displayOrder||0));
                f?.fields?.filter(f => f.enabled == true || f?.childFields?.length > 0)?.map(x => {
                    //nested field
                    if (x?.childFields?.length > 0) {
                        x.childFields?.filter(n => n.enabled == true)?.map(nestObj => {
                            columns.push(
                                {
                                    id: nestObj.id,
                                    field: nestObj.columnName,
                                    header: `${x.name}: ${nestObj.name}`,
                                    fieldNameDB: nestObj.columnName,
                                    dataType: nestObj.fieldDataType == 'DateTime' ? 'date' : (nestObj.fieldDataType == 'Number' || nestObj.fieldDataType == 'Decimal') && nestObj.name != 'Qty' ? 'number' : nestObj.fieldDataType == 'Money' ? 'currency' : 'string',
                                    fieldDataType: nestObj.fieldDataType,
                                    formControlType: nestObj?.formControlType,
                                    isShow: nestObj.enabled,
                                    isCommaSeperated: (this.selectedSearch?.objectId == ActivityModuleId) ? ActivityCommaSeparatedControls.includes(x.formControlType) : CommaSeparatedControls.includes(x.formControlType),
                                    isCustom: nestObj.isCustom,
                                    isDateWithTime: nestObj?.isDateWithTime || false,
                                    isCsv: CSVControls.includes(x.formControlType)
                                });
                        })
                    }
                    else {
                        let dataType: any = x.fieldDataType == 'DateTime' ? 'date' : (x.fieldDataType == 'Number' || x.fieldDataType == 'Decimal') ? 'number' : x.fieldDataType == 'Money' ? 'currency' : 'string';

                        if(x?.formControlType=='Currency'){
                            dataType = 'currency';
                        }

                        if(x?.formControlType=='Time'){
                            dataType = 'time';
                        }

                        columns.push(
                            {
                                id: x.id,
                                field: x.columnName,
                                header: x.name,
                                fieldNameDB: x.columnName,
                                dataType: dataType,
                                fieldDataType: x.fieldDataType as any,
                                formControlType: x?.formControlType,
                                isShow: x.enabled,
                                isCommaSeperated: (this.selectedSearch?.objectId == ActivityModuleId) ? ActivityCommaSeparatedControls.includes(x.formControlType) : CommaSeparatedControls.includes(x.formControlType),
                                isCustom: x.isCustom,
                                isDateWithTime: x?.isDateWithTime || false,
                                isCsv: CSVControls.includes(x.formControlType),
                                currencySymbol: x?.currencySymbol,
                            });
                    }
                });
            });
            // console.log(this.selectedSearch);
            selectedColums.listViewSections = selectedColums.listViewSections.sort((a,b)=> (a?.displayOrder||0) - (b?.displayOrder||0));
        }

        return columns;
    }

    getColumnSettings(addEditType: 'Select' | 'View' | 'Edit' | 'Delete' | 'None'): void {
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedColumnSettingsService.getColumnSettingsForSavedSearch(this.selectedSearch.objectId, this.selectedSearch.channelId, this.selectedSearch?.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                {
                    next: (response) => {
                        this.columnSettingsN = response || {};
                        this.selectedSearch.columns = [];
                        setTimeout(() => {
                            this.selectedSearch.columns = this.getLAColumnSettingsForTable(this.columnSettingsN);
                            if (addEditType == 'Select') {
                                // this.onChangeRange({ dateFrom: this.dateFrom, dateTo: this.dateTo, code: this.dateCode, label: this.dateCode });
                                this.filterByInputValue = [];
                                this.resetResultPagination();
                                this.getSavedSearchResultOnListIndex(1, this.pageSize2);
                            }
                        }, 0);

                        this.appMainService.isHideSpinner('getColumnSettings');
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getColumnSettings');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                        });
                    },
                    complete: () => {

                    },
                });
    }

    savedColumnSettings(data: { updatedColumnSettings: any, updateColumnSettingsData: any }): void {
        let requestbody = {
            moduleId: this.selectedSearch?.objectId,
            channelId: this.selectedSearch?.channelId,
            savedSearchId: this.selectedSearch?.id,
            listViewFields: data?.updateColumnSettingsData?.listViewFields,
            listViewSections: data?.updateColumnSettingsData?.listViewSections
        }
        this.sharedColumnSettingsService.updateColumnSettingsForSavedSearch(requestbody).subscribe({
            next: (result) => {
                this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: SavedSearchMessage.saveSearchaveColSettngSuccessMsg });
                this.displayColumnSettings = false;// close column settings
                this.selectAllSectionsFields = false;
                this.resetFilterAndDate();
                this.selectSavedSearch();
            }
        })
    }

    cancelColumnSettings(): void {
        this.displayColumnSettings = false;
        this.selectAllSectionsFields = false;
        
    }

    calculateColumnSettingsMax(): void {
        this.totalAmt = 0;
        for (let section of this.selectedSearch?.savedSearchColumnSetting) {
            this.totalAmt = this.totalAmt + section?.fields?.filter(x => x.isSelected == true && !(x.nestedFields?.length > 0))?.length ?? 0;
            this.totalAmt = this.totalAmt + section?.fields?.filter(x => x.nestedFields?.length > 0)?.filter(y => y.isSelected == true)?.length ?? 0;
        }
    }


    //In Page Column Settings

    showColumnSetting() {
        this.colSettingSearchInput = '';
        if ([AccountModuleId, TaskModuleId, LeadModuleId, OpportunityModuleId, ActivityModuleId, VendorModuleId, LocationModuleId].includes(this.selectedSearch?.objectId)) {
            this.displayColSetting = false;
            this.displayColumnSettings = true;
        } else {
            this.displayColSetting = true;
            this.displayColumnSettings = false;
            this.selectedSearch.savedSearchColumnSetting = ParseHelper.DeepCopy(this.tempColumnSettings);
            this.calculateColumnSettingsMax();
        }
    }

    updateColumnSettings() {
        const columnSettignsObj: SavedSearchNS.IUpdateColumnSettings = {
            savedSearchId: this.selectedSearch.id,
            columns: JSON.stringify(this.selectedSearch.savedSearchColumnSetting, null, null),
            updatedSource: 'string'
        };
        this.appMainService.isShowSpinner('updateColumnSettings');
        this.savedSearchesService.updateColumnSettings(columnSettignsObj)
            .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
                this.appMainService.isHideSpinner('updateColumnSettings');
                this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: SavedSearchMessage.saveSearchaveColSettngSuccessMsg });
                this.displayColSetting = false;// close column settings
                this.resetFilterAndDate();
                this.selectSavedSearch();
            },
                (error) => {
                    this.appMainService.isHideSpinner('updateColumnSettings');
                    this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: SavedSearchMessage.saveSearchaveColSettngErrorMsg });
                });
    }

    onCancelColumnSettingsPopUp() {
        this.displayColSetting = false;
        this.selectAllSectionsFields = false;
    }

    dropListCol(event: CdkDragDrop<string[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    cdkDragStarted(event: CdkDragStart) {
        this.startDrag = true;
    }

    cdkDragReleased() {
        this.startDrag = false;
    }

    toggleChilds(section: any) {
        section['hideChilds'] = !section?.hideChilds;
    }

    dropCol(event: CdkDragDrop<string[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    onCheckChange(isChecked: boolean, col: any, nestedCols: any) {
        if (isChecked) {
            if (this.totalAmt <= 30) {
                this.totalAmt++;
            }
            if (nestedCols && col) {
                col.isSelected = true;
            }
        }
        else {
            this.totalAmt--;
            if (nestedCols && col) {
                col.isSelected = nestedCols?.find(x => x?.isSelected == true) ? true : false;
            }
        }
        this.maxNo = this.totalAmt >= 30;
    }

    showChild(col: any) {
        col.showChildrens = col?.showChildrens != undefined ? !col.showChildrens : true;
    }

    setColumnFlag(col) {
        if (col.isSelected) {
            const present = this.disabledLabelNames?.find(columnName => columnName.toLowerCase() == col.fieldName.toLowerCase());
            if (present) {
                return true;
            }
        }

        return false;
    }

    //#endregion

    //#region ***Module Data Edit***

    onRouteNavigation(rowData: any, col: ISavedSearchColumnModel) {
        let moduleId = this.selectedSearch.objectId;
        this.selectedChannelIdForView = this.selectedChannelId
        let id = rowData?.Id;

        if (this.selectedSearch.objectId == ActivityModuleId) {
            moduleId = rowData.moduleId;
            id = rowData.associationId;
            this.selectedChannelIdForView = rowData.associatedChannelId;
        }

        if(this.inventoryHiperLinkFields.includes(col?.fieldNameDB?.toLowerCase())){
            switch (col?.fieldNameDB?.toLowerCase()) {
                case 'trans_invoiceno':
                    this.openInventoryOverview(this.transactionNames.Invoice, rowData[col.field]);
                    break;
                case 'trans_salesorderno':
                    this.openInventoryOverview(this.transactionNames.SalesOrder, rowData[col.field]);
                    break;
                case 'trans_rmano':
                    this.openInventoryOverview(this.transactionNames.CustomerRMA, rowData[col.field]);
                    break;
                case 'trans_memonumber':
                    this.openInventoryOverview(this.transactionNames.CreditMemo, rowData[col.field]);
                    break;
                case 'trans_estimateno':
                    this.openInventoryOverview(this.transactionNames.Estimate, rowData[col.field]);
                default:
                    
                    break;
            }
        }else{
            switch (moduleId) {
                case LeadModuleId:
                    this.openLeadViewEdit(id);
                    break;
                case AccountModuleId:
                    this.openAccountViewEdit(id);
                    break;
                case OpportunityModuleId:
                    this.openOpportunityViewEdit(id);
                    break;
                case TaskModuleId:
                    this.openTaskViewEdit(id);
                    break;
                case VendorModuleId:
                    this.openVendorView(id);
                    break;

                default:
                    break;
            }
        }
    }

    openInventoryOverview(moduleName: string, title: string, id: number = 0){
        this.inventoryOverviewRefId = id;
        this.inventoryOverviewRefNumber = title;
        this.inventoryOverviewModule = moduleName;
        this.displayInventoryOverview = true;
    }

    

    closeViewPopup(){
        this.displayInventoryOverview = false;
    }

    reloadResultAfterSave() {
        this.filterByInputValue = [];
        this.resetResultPagination();
        this.getSavedSearchResultOnListIndex(1, this.pageSize2);
    }

    openAccountViewEdit(accountId: number) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = accountId;
    }

    closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
    }

    openLeadViewEdit(leadId: number) {
        this.displayLeadViewEdit = true;
        this.selectedLeadId = leadId;
    }
    openTaskViewEdit(TaskId: number) {
        this.app.selectedTaskId = TaskId;
        this.app.displayEditViewTask = true;
    }

    closeLeadViewEdit() {
        this.displayLeadViewEdit = false;
        this.selectedLeadId = 0;
    }

    openOpportunityViewEdit(opportunityId: number) {
        this.displayOpportunityViewEdit = true;
        this.opportunityEditViewId = opportunityId;
    }

    closeOpportunityViewEdit() {
        this.displayOpportunityViewEdit = false;
        this.opportunityEditViewId = 0;
    }

    openVendorView(vendorId: number){
        this.purchaseService.getVendorById(vendorId).subscribe(vendor => {
          this.selectedVendorDetails = vendor;
          this.displayVendorOverview = true;
      })
      }

    closeVendorView($event) {
        this.displayVendorOverview = false;
        this.selectedVendorDetails = null;
        
      }

    //#endregion

    //#region Export Saved Search

    onExport() {
        this.displayExportDialog = true;
    }

    downloadSavedSearch(type: 'open'|'pdf'|'csv'|'xlsx'){
        this.getSavedSearchResultOnListIndex(0,0,type);
    }

    showCSVFile(url: string) {
        this.documentViewerService.selectDocumentType('xlsx', url);
    }

    downloadFile(url:string){
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }

    exportToExcel(resultData: any[], exportType: string) {
        let dataToExport = [];

        const reportTotalRow = {};

        if (this.groupByParams?.aggregatedFields?.length > 0 && resultData?.length > 0) {
            reportTotalRow['Aggregated_GroupNameCount'] = resultData[0]?.Aggregated_GroupNameCount;
            const keys = Object.keys(resultData[0]);
            for (let k of keys) {
                const dt = this.groupByParams.aggregatedFields.filter(ky => ky.columnName == k)[0];
                if (dt) {
                    const field = `Aggregated_${dt.columnName}`;
                    const paginatedField = `Paginated_${dt.columnName}`;
                    reportTotalRow[dt.columnName] = resultData[0]?.[field];
                    reportTotalRow[paginatedField] = resultData[0]?.[paginatedField];
                }
            }
        }

        // If grouped
        if (this.fromGroupBy) {
            resultData.map(rowData => {

                let groupParentRow = {};
                let groupHeader = `Group: ${this.groupByParams.groupBy.labelName}`;
                let groupName = (rowData.GroupNameValue || rowData.GroupNameValue === false || rowData.GroupNameValue === 0) ? (rowData.GroupNameValue) : 'NA';
                if (this.groupByParams?.groupBy?.dataType == 'DateTime') {
                    groupName = rowData.GroupNameValue ? (this.datePipe.transform(rowData.GroupNameValue,'MM/dd/yyyy')) : 'NA';
                }
                groupName = `${groupName} (${rowData.GroupNameCount})`;

                groupParentRow[groupHeader] = groupName;
                dataToExport.push(groupParentRow);

                if (this.groupByParams?.subGroupBy?.columnName) {
                    //Sub Group Start
                    rowData.SavedSearchResult.map(groupData => {
                        let subgroupParentRow = {};
                        let subGroupHeader = `Sub Group: ${this.groupByParams.subGroupBy.labelName}`;
                        let subGroupName = (groupData.InnerGroupNameValue || groupData.InnerGroupNameValue === false || groupData.InnerGroupNameValue === 0) ? (groupData.InnerGroupNameValue) : 'NA';
                        if (this.groupByParams?.subGroupBy?.dataType == 'DateTime') {
                            subGroupName = groupData.InnerGroupNameValue ? (this.datePipe.transform(groupData.InnerGroupNameValue,'MM/dd/yyyy')) : 'NA';
                        }
                        subGroupName = `${subGroupName} (${groupData.InnerGroupNameCount})`;

                        subgroupParentRow[groupHeader] = "";
                        subgroupParentRow[subGroupHeader] = subGroupName;
                        dataToExport.push(subgroupParentRow);

                        groupData.InnerSavedSearchResult.map(subData => {
                            let subGroupRow = {};
                            subGroupRow[groupHeader] = "";
                            subGroupRow[subGroupHeader] = "";
                            this.selectedSearch.columns.forEach(col => {
                                if (col.isShow && col.field !== this.groupByParams.groupBy.columnName && col.field !== this.groupByParams.subGroupBy.columnName) {
                                    subGroupRow[col.header] = this.formatData(subData[col.field], col);
                                }
                            });
                            dataToExport.push(subGroupRow);
                        });

                        // Add sub group total if not Count aggregation
                        if (this.groupBySavedResults.aggregationType !== 'Count') {
                            let subGroupTotalRow = {};
                            subGroupTotalRow[groupHeader] = "";
                            subGroupTotalRow[subGroupHeader] = `Sub Group ${this.groupBySavedResults?.aggregationType == 'Sum' ? 'Total' : this.groupBySavedResults?.aggregationType}`;
                            this.selectedSearch.columns.forEach(col => {
                                if (col.isShow && col.field !== this.groupByParams.groupBy.columnName && col.field !== this.groupByParams.subGroupBy.columnName) {
                                    subGroupTotalRow[col.header] = this.formatData(groupData[col.field], col);
                                }
                            });
                            dataToExport.push(subGroupTotalRow);
                        }
                    });
                    //Sub Group End
                } else {
                    rowData.SavedSearchResult.map(s => {
                        let groupRow = {};
                        groupRow[groupHeader] = "";
                        this.selectedSearch.columns.forEach(col => {
                            if (col.isShow && col.field !== this.groupByParams.groupBy.columnName && col.field !== this.groupByParams?.subGroupBy?.columnName) {
                                groupRow[col.header] = this.formatData(s[col.field], col);
                            }
                        });
                        dataToExport.push(groupRow);
                    });
                }

                // Add group total if not Count aggregation
                if (this.groupBySavedResults.aggregationType !== 'Count') {
                    let groupTotalRow = {};
                    groupTotalRow[groupHeader] = `Group ${this.groupBySavedResults?.aggregationType == 'Sum' ? 'Total' : this.groupBySavedResults?.aggregationType}`;
                    this.selectedSearch.columns.forEach(col => {
                        if (col.isShow && col.field !== this.groupByParams.groupBy.columnName && col.field !== this.groupByParams?.subGroupBy?.columnName) {
                            groupTotalRow[col.header] = this.formatData(rowData[col.field], col);
                        }
                    });
                    dataToExport.push(groupTotalRow);
                }
            });
        } else {
            // If not grouped, export as simple table
            dataToExport = resultData.map(row => {
                const rowData = {};
                this.selectedSearch.columns.forEach(col => {
                    if (col.isShow) {
                        rowData[col.header] = this.formatData(row[col.field], col);
                    }
                });
                return rowData;
            });
        }

        // Add footer totals if present
        if (!this.fromGroupBy && this.groupByParams?.aggregatedFields?.length>0) {
            let totalRow = {};
            this.selectedSearch.columns.filter(col=> col.isShow).map((col, index) => {
                if(index==0){
                    totalRow[col.header] = this.groupBySavedResults?.aggregationType=='Sum'?'Grand_TOTAL':(this.groupBySavedResults?.aggregationType?
                        'Grand_'+this.groupBySavedResults?.aggregationType: ""
                        )
                }else{
                    totalRow[col.header] = this.formatData(reportTotalRow[col.field], col, true);
                }
            });
            dataToExport.push(totalRow);
        }

        if (this.fromGroupBy && this.groupByParams?.aggregatedFields?.length>0) {
            let totalRow = {};
            let groupHeader = `Group: ${this.groupByParams.groupBy.labelName}`;
            if(this.groupByParams?.subGroupBy?.columnName){
                let subGroupHeader = `Sub Group: ${this.groupByParams.subGroupBy.labelName}`;
                totalRow[subGroupHeader] = "";
            }

            totalRow[groupHeader] = this.groupBySavedResults?.aggregationType=='Sum'?'Grand_TOTAL':(this.groupBySavedResults?.aggregationType?
                'Grand_'+this.groupBySavedResults?.aggregationType: ""
                );

            if(this.groupBySavedResults?.aggregationType=='Count'){
                totalRow[groupHeader] = `${totalRow[groupHeader]} (${reportTotalRow[this.groupByParams?.groupBy?.columnName]||reportTotalRow['Aggregated_GroupNameCount']})`
            }

            this.selectedSearch.columns.filter(col=> col.isShow).map((col, i) => {
                if((this.groupByParams?.groupBy?.columnName && col.field!=this.groupByParams?.groupBy?.columnName && col.field!=this.groupByParams?.subGroupBy?.columnName) || (!this.fromGroupBy && i!=0)){
                    totalRow[col.header] = this.formatData(reportTotalRow[col.field], col, true);
                }
            });
            dataToExport.push(totalRow);
        }

        if(exportType=='pdf'){
            const themeColor = this.cookieStoreService.getThemeColor();
            const pdfName = this.concatDateName(this.selectedSearch.name);
            let options = new PrintPdfModel.PrintPdfOptions('landscape','mm','a1');
            let cellWidth: number = null;
            const enabledColumns = this.selectedSearch.columns.filter(col=> col.isShow);
            const mostPropertiesRow = dataToExport.findIndex(obj=> Object.keys(obj).length==enabledColumns.length);
            const pdfcolumns = [];
            Object.keys(dataToExport[mostPropertiesRow]).map(header=>{
                pdfcolumns.push({ dataKey: header, header: header });
            });

            if(pdfcolumns?.length>8){
                cellWidth = 812/pdfcolumns?.length; //A1 size in amm
            }else {
                options = null;
                cellWidth = 268/pdfcolumns?.length; //A4 size in mm
            }

            ReportsPrintPdfService.openOrExportAsPDF(pdfcolumns, dataToExport, this.app.user.organizationName, null, null, pdfName, options, null, false,themeColor, cellWidth);
            this.displayExportDialog = false;
            this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: "Export request is completed..." });
        }else{
            const excelType = exportType=='csv' ? 'csv' : 'xlsx';
            import("xlsx").then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(dataToExport);
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer: any = xlsx.write(workbook, { bookType: excelType, type: 'array' });
                this.saveAsExcelFilexlsx(excelBuffer, this.selectedSearch.name, true, exportType as any);
            });
        }
    }

    formatData(data: any, col: any, numberToFixed: boolean = true): any {
        if (data === null || data === undefined) {
            return '';
        }
        switch (col.dataType) {
            case 'date':
                if(col?.isCustom && col.isDateWithTime){
                    return this.localDatePipe.transform(data,'dateTime',false);
                }
                return col.isDateWithTime ? this.localDatePipe.transform(data,'MM/DD/YYYY') : new Date(data).toLocaleDateString();
            case 'time':
                return this.onlyTimePipe.transform(data);
            case 'number':
                if(numberToFixed){
                    data = this.numberToFixedPipe.transform(data);
                }
                return (col.header === 'Probability' || col.header === 'Rep Confidence' || col?.formControlType=='Percentage') ? `${data}%` : data;
            case 'currency':
                data = data ? this.customNumberFormatPipe.transform(data, this.maximumFractionDigits) : data;
                return this.currencyPipe.transform(data, null, col?.currencySymbol?.trim());
            default:
                if(col?.formControlType=='EncryptedText'){
                    return "";
                }
                return data ? this.removeHtmlTags.transform(data) : data;
        }
    }

    saveAsExcelFilexlsx(buffer: any, fileName: string, showMsg: boolean = true, exportType: 'open'|'xlsx'|'csv' = 'xlsx'): void {

        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXTENSION = 'xlsx';

        switch(exportType){
            case 'csv':
                EXCEL_TYPE = 'text/csv;charset=UTF-8';
                EXTENSION = 'csv';
            break;
        }

        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });

        fileName = this.concatDateName(fileName);
        const file = new File([data], fileName, { type: data.type });
        this.appMainService.isShowSpinner('exportToCSV');
        this.documentService.uploadExportedFile('SavedSearch',fileName, EXTENSION, file).subscribe({
            next: (response)=>{
                this.appMainService.isHideSpinner('exportToCSV');
                if(exportType=='open'){
                    this.showCSVFile(response?.encodedDownloadLink);
                }else{
                    this.downloadFile(response?.downloadLink);
                }
                this.displayExportDialog = false;
                this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: "Export request is completed..." });
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('exportToCSV');
                this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: "Error Occured..." });
            }
        })
    }

    concatDateName(name: string){
        const currentDate = this.timeZoneService.showDateTimeWithZone(new Date());
        let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Adding leading zero to month
        let date = String(currentDate.getDate()).padStart(2, '0'); // Adding leading zero to date
        let hours = String(currentDate.getHours()).padStart(2, '0'); // Adding leading zero to hours
        let minutes = String(currentDate.getMinutes()).padStart(2, '0'); // Adding leading zero to minutes
        let seconds = String(currentDate.getSeconds()).padStart(2, '0'); // Adding leading zero to seconds

        let dateName = `${month}_${date}_${currentDate.getFullYear()}`;
        dateName = `${dateName}-${hours}_${minutes}_${seconds}`;
        return `${name} ${dateName}`;
    }

    //#endregion

    //#region  ***Saved Search Map***

    changeViewMode(){
        if(this.savedSearchMapView=='map'){
            setTimeout(()=>{
                this.initSavedSearchMap();
            },100)
        }
    }

    async initSavedSearchMap(){

        const { Map } = await google.maps.importLibrary("maps");

        var mapOptions = {
            zoom: 10,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            disableDefaultUI: false,
            draggable: true,
            scrollwheel: true,
            disableDoubleClickZoom: false,
            panControl: true,
            streetViewControl: true,
            overviewMapControl: true,
            mapTypeControl: true,
            scaleControl: true,
            rotateControl: true,
            fullscreenControl: true,
            mapId: "656915a1a1b695a4"
        };

        this.savedSearchMap = new Map(document.getElementById('map'), mapOptions);
        const globalThis = this;
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode( {}, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                let lat = results[0].geometry.location.lat;
                let lng = results[0].geometry.location.lng;

                globalThis.savedSearchMap.setCenter(results[0].geometry.location);
                globalThis.savedSearchMap.fitBounds(results[0].geometry.viewport);
            }
        });
        this.setSavedSearchMapMarkers(this.resultData,this.savedSearchMap)

    }


    setSavedSearchMapMarkers(accountList,map ){
        if(accountList?.length>0){
            this.addMarkers(map,accountList);
        }
    }

    addMarkers(map,accountList){
        this.mapInfoWindow = new google.maps.InfoWindow();
        let bounds = new google.maps.LatLngBounds();
        let markerCount = 0;
        accountList.map((objectDetails, index)=>{
            let markerLatLng = {
                lat: objectDetails.Latitude,
                lng: objectDetails.Longitude,
            }
            if(isValidLatLng(markerLatLng.lat,markerLatLng.lng)){
                markerCount++;
                bounds.extend(markerLatLng);
                const advancedMarkerView = new google.maps.marker.AdvancedMarkerElement({
                    map,
                    content: this.buildContent(objectDetails),
                    position: markerLatLng,
                    title: objectDetails.businessName
                });

                advancedMarkerView.addListener('click', () => {
                    const detailsList = this.setMapDetails(objectDetails);
                    const content = `<div class="map-marker-details-wrapper">
                                        <div class="marker-details-header">
                                            <h5>${objectDetails.businessName}</h5>
                                            <span class="close-icon pi pi-times" onclick="window.cpntRef.zone.run(() => {window.cpntRef.component.closeInfoWindow();})"></span>
                                        </div>
                                        <div class="marker-details-body">
                                            <div class="marker-details-wrapper">
                                                ${detailsList}
                                            </div>
                                        </div>
                                    </div>`;
                    this.mapInfoWindow.close();
                    this.mapInfoWindow.setContent(content);
                    this.mapInfoWindow.open(advancedMarkerView.map, advancedMarkerView);
                });

                this.savedSearchMapMarkers.push(advancedMarkerView);
            }
        });
        if(bounds){
            map.fitBounds(bounds);
            map.setCenter(bounds.getCenter());
        }

    }

    buildContent(objectDetails: any) {
        const content = document.createElement("div");

        content.classList.add("map-marker");
        content.innerHTML = `
            <div class="marker-wrapper">
                <div class="icon">
                    <div class="marker-pin" style="--marker-color: ${objectDetails?.stageColor||'#3381CC'}"></div>
                </div>
            </div>
          `;
        return content;
    }

    setMapDetails(rowData: any){

        let detailsList: string = "";

        this.selectedSearch.columns.map(col=>{

            if(col?.isShow && col?.header && rowData[col?.field]){

                let viewData = rowData[col?.field];

                switch(col?.dataType){
                    case 'date':
                        if(rowData[col.field] && col?.isDateWithTime){
                            viewData = this.localDatePipe.transform(rowData[col?.field],'date');
                        }else{
                            viewData = this.datePipe.transform(rowData[col?.field],'MM/dd/yyyy');
                        }
                    break;
                    case 'number':
                        if((col?.header=='Probability' || col?.header=='Rep Confidence')){
                            viewData = (rowData[col.field] || rowData[col.field]==0) ? rowData[col.field]+'%' : '';
                        }

                    break;
                    case 'currency':
                        if((this.checkDataType(rowData[col.field])=='string' && rowData[col.field]?.includes(','))){
                            viewData = this.convertToCurrency(rowData[col.field]);
                        }else{
                            viewData = this.currencyPipe.transform(rowData[col.field],'number2dp')
                        }
                    break;
                }

                detailsList = detailsList.concat(`
                    <div class="marker-details-list">
                        <div class="marker-details-label">${col.header}</div>
                        <div class="marker-details-info">${viewData}</div>
                    </div>
                `);
            }
        });

        return detailsList;
    }

    closeInfoWindow(){
        this.mapInfoWindow?.close();
    }

    //#endregion ***Saved Search Map End***

    
    enableAllSectionFields($event: any, sections: any[]) {
        const checked = !!$event?.checked;
        this.selectAllSectionsFields = checked;
        // this.isSelectAllSectionField = checked;
        if(sections?.length>0){
            for (let s = 0; s < sections.length; s++) {
                if (checked && this.isMaxFieldsSelected()) break;
                const section = sections[s];
                this.enableSectionFields({checked: checked}, section);
            }
        }
    }

    enableSectionFields($event: any, section: any) {
        const checked = !!$event?.checked;
        for (let f = 0; f < section.fields.length; f++) {
            if (checked && this.isMaxFieldsSelected()) break;
            const field = section.fields[f];
            if (field?.nestedFields?.length) {
                for (let i = 0; i < field.nestedFields.length; i++) {
                    if (checked && this.isMaxFieldsSelected()) break;
                    const childField = field.nestedFields[i];
                    const isChildDisabled = ((childField.isRequired && childField.isSelected) ||
                        (this.disabledLabelNames.includes(childField.fieldName) && childField.isSelected)
                    );

                    const enabled = isChildDisabled ? true : checked;

                    if(childField.isSelected!=enabled){
                        childField.isSelected = enabled;
                        this.onCheckChange(enabled, field, null);
                    }
                }
            } else {
                const isDisabled = ((field?.fieldName == 'BusinessName') ||  (field?.fieldName == 'Name') || (field?.fieldName == 'ItemNo') || (field?.fieldName == 'Number') || field?.columnName == 'taskId') ||
                                   (this.disabledLabelNames.includes(field.fieldName) && field.isSelected) || this.setColumnFlag(field);
                               

                const enabled = isDisabled ? true : checked;
                if(field.isSelected!=enabled){
                    field.isSelected = enabled;
                    this.onCheckChange(checked, field, null);
                }
            }
        }
    }

    
    isMaxFieldsSelected(){
       return  this.totalAmt >=30;
    }

    ngOnDestroy(): void {
        window["cpntRef"] = null;
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

}
